module.exports = __webpack_public_path__ + "static/img/sign_bg.d6d3542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sign_bg.png
// module id = n7ju
// module chunks = 10